export enum PtUiAppRoutes {
  LOGIN = 'login',
  LOADER = 'loader',
  MFA = 'mfa',
  HOME = 'home',
  REMINDER = 'reminder',
  PROFILE = 'profile',
  CHANGE_EMAIL = 'change-email',
  DPIA = 'dpia',
  OAUTH = 'oauth',
  LIA = 'lia',
  EXTRACTION = 'extraction',
  CHANGE_PASSWORD = 'change-password',
  CHANGE_EMAIL_CONFIRM = 'change-email-confirm',
  DATA_PROTECTION_GOVERNANCE = 'data-protection-governance',
  LEGAL_ENTITY = 'legal-entity',
  REGULATIONS = 'regulations',
  PROJECT_CARDS = 'project',
  APPOINTMENTS = 'appointments',
  APPLICATIONS = 'applications',
  RECIPIENTS = 'recipients',
  NOTICES = 'notices',
  ORGANIZATIONAL_FUNCTIONS = 'organizational-functions',
  NATURE_OF_DATA = 'nature-of-data',
  PRIVACY_ROLES = 'privacy-role',
  LEGAL_BASIS = 'legal-basis',
  EMPLOYMENT_RELATIONSHIP = 'employment-relationship',
  INTERESTED_PERSON_CATEGORIES = 'interested-person-categories',
  SUPPLIERS = 'suppliers',
  APPLICATION_TYPES = 'application-types',
  TREATMENT_CATEGORY = 'treatment-category',
  DEPARTMENTS = 'department',
  PRELIMINARY_RISK_ASSESSMENTS = 'preliminary-risk-assessment',
  SECURITY_MEASURES = 'security-measures',
  SECURITY_MEASURE_CATEGORIES = 'security-measure-categories',
  DAMAGES = 'damage',
  MAIL_HISTORY = 'mail-history',
  PERMISSION_RULES = 'permission-rules',
  TECHNICAL_MEASURE_CATEGORIES = 'technical-measure-categories',
  TECHNICAL_MEASURES = 'technical-measures',
  BUSINESS_MANAGEMENT = 'business-management',
  TREATMENTS_HOLDER = 'controller',
  TREATMENTS_RESPONSIBLE = 'processor',
  TREATMENTS_SUB_RESPONSIBLE = 'sub-processor',
  GLOBAL_MEASURE_CHECK = 'global-measure-check',
  APP_ASSESSMENTS = 'app-assessment',
  AI_ASSESSMENTS = 'ai-assessment',
  COVID_ASSESSMENTS = 'remote-working',
  COVID_TEMPLATE = 'covid-template',
  PURPOSE_CATEGORIES = 'purpose-categories',
  WORKSPACE = 'workspace',
  SEARCH = 'search',
  RESOURCES = 'resources',
  TUTORIALS = 'tutorials',
  ADMINISTRATION_AND_CONFIGURATION = 'administration-configuration',
  SETTINGS = 'setting',
  USER_GROUPS = 'user-groups',
  USERS = 'users',
  CREATE = 'create',
  FORBIDDEN = 'forbidden',
  ERROR = 'error',
  EDIT = 'edit',
  USERS_RESOURCES = 'users-resources',
  CREATE_APPOINTMENT_AUTHORIZED = 'create-authorized',
  CREATE_APPOINTMENT_RESPONSIBLE = 'create-responsible',
  CREATE_APPOINTMENT_SYSTEM_ADMIN = 'create-system-admin',
  INCIDENT_REPORT = 'incident-report',
  DATA_BREACH_CONFIGURATION = 'data-breach-configuration',
  DATA_BREACHES = 'data-breaches',
  DATA_BREACH = 'data-breach',
  DATA_BREACHES_REGISTER = 'register',
  GENERIC_REPORT = 'generic-report',
  DATA_BREACHES_VIEWER = 'viewer',
  CYBER_SECURITY = 'cyber-security',
  INCIDENT_TEAM = 'incident-team',
  FORBIDDEN_MODULE = 'forbidden-module',

  ASSESSMENT_QUESTION = 'assessment-question',
  DEBUG = 'debug',

  DEBUG_TEMPLATE = 'template'
}

// export enum AppointmentsTabs {
//   APPOINTMENT_AUTHORIZED = 'APPOINTMENT_AUTHORIZED',
//   APPOINTMENT_RESPONSIBLE = 'APPOINTMENT_RESPONSIBLE',
//   APPOINTMENT_SYSTEM_ADMIN = 'APPOINTMENT_SYSTEM_ADMIN'
// }
